// extracted by mini-css-extract-plugin
export default {"Collection":"style_Collection__gyU63","gridLayout":"style_gridLayout__R89Yw","listLayout":"style_listLayout__Uprk4"};